import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { CaseDataService } from 'src/app-client/_dataservices/CaseDataService';
import { ControllerBase } from 'src/app/_appCommon/base/ControllerBase';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { OpenpayService } from 'src/app-client/_dataservices/security/OpenpayService';
import { OrderDataService } from 'src/app-client/_dataservices/OrderDataService';
import { PaymentType } from 'src/app/_appCommon/base/AppInterfaceAndBaseClasses';
import { ProductDetail, Service, ServiceType, ShoppingCartItem } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { ShoppingCartDataService } from 'src/app-client/_dataservices/ShoppingCartDataService';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { CasePurchasedOrdersDataService } from 'src/app-client/_dataservices/CasePurchasedOrdersDataService';
@Component({
  selector: 'app-paylink-form',
  templateUrl: './paylink-form.component.html',
  styleUrls: ['./paylink-form.component.css'],
  providers: [OpenpayService, OrderDataService, CustomerDataService, CaseDataService, CasePurchasedOrdersDataService]
})
export class PaylinkFormComponent extends ControllerBase  implements OnInit, AfterViewInit {

  public chargeDataForm: FormGroup;
  public chargeObject: any;
  public currentCart: ShoppingCartItem[] = null;
  public currentCustomer: any; // current logged-in customer
  public customerObject: any;
  public displayObject: string = "inputForm";
  public paymentId: string = "";
  public purchaseDataForm: FormGroup;
  public urlPDF: string = "";
  public purchaseCode: string = "";
  public total: number =0;
  public loadingPayment: boolean = true;
  public orderId: number;
  public currentOrder: any;
  constructor(
    private caseDataService: CaseDataService,
    private casePurchasedOrdersDataService: CasePurchasedOrdersDataService,
    private customerDataService: CustomerDataService,
    private openpay: OpenpayService,
    private orderService: OrderDataService,
    private router: Router,
    public shoppingCartDataService: ShoppingCartDataService,
    public activatedRoute:ActivatedRoute
  )
  {
    super();
  }

  ngOnInit(): void
  {
    this.total = this.shoppingCartDataService.getTotal()
    this.shoppingCartDataService.getItems()
      .subscribe(cart =>
      {
        this.currentCart = cart;
      });

  }

  ngAfterViewInit(): void
  {
    this.activatedRoute.queryParamMap.subscribe(params => {
      setTimeout(() => {
        this.orderId = +params.get('orderId');
        if(this.orderId != 0)
        {
          this.orderService.getById(this.orderId, this.onGetQueryDefForGetById())
          .subscribe((response) => {
            this.currentOrder = response;
            this.total=this.currentOrder.orderDetail[0].total
            this.doPendingPayment();
          });
          
        }
        else
        {
          this.getCustomerInfo();
        }
   


      });
    });

  }

  private getCustomerInfo()
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((customerResponse: any) =>
        {
          this.currentCustomer = customerResponse.items.firstOrNull();
          if (this.currentCustomer)
          {
            AppClientContext.Instance.customerId = this.currentCustomer.id;
            this.doPayment();
          }
          else
          {
            this.router.navigate(["/ecommerce"]);
          }
        });
    }
    else
    {
      this.router.navigate(["/ecommerce"]);
    }
  }

  public doPayment()
  {
    this.loadingPayment = true;
    this.getCustomerObject();
    this.setInfoAlert("Procesando, por favor espere...");
    this.getChargeObject();

    this.paymentId = "";
    this.setSuccessAlert("Operación completada con éxito");

    let body: any = {
      reference: this.paymentId
    };

    this.loadingPayment = false;

    this.postOrder("",'in_progress');
  }

  public doPendingPayment()
  {
    this.loadingPayment = true;
    this.setInfoAlert("Procesando, por favor espere...");
    let body ={
      id: this.orderId,
      paymentType: PaymentType.PayLink
    };
    this.orderService.updateOrderPaymentType(body)
    .subscribe(()=>
    {
      this.setSuccessAlert("Operación completada con éxito");
      this.loadingPayment = false;
    })
  }
  

  public openPayment()
  {
    window.open(this.urlPDF, '_blank', 'noreferrer');
  }

  public exitPayment()
  {
    this.router.navigate(["/ecommerce"]);
  }

  // create the purchase order
  private postOrder(responseDescription: string,reponsePayment: any)
  {
    this.purchaseCode = responseDescription;
    const orderBody: any = {
      "Comments": "Compra: "+responseDescription+" en Aliwell via PayLink",
      "PaymentType": PaymentType.PayLink,
      "PaymentTransactionId": this.paymentId,
      "CustomerId": this.currentCustomer.id,
      "CouponId": null,
      "ProductDetailList": this.getOrderDetailList(),
      "PaymentStatus": reponsePayment == 'in_progress' ? 0 : null,
      "Code": this.purchaseCode,
      "CaseId": this.shoppingCartDataService.caseId
    };

    this.orderService.createOrder(orderBody)
      .subscribe((res) =>
      {
        if (this.shoppingCartDataService.caseId !== null )
        {
          this.shoppingCartDataService.lastOrderId = res.id;
          this.addCasePurchasedOrders(this.shoppingCartDataService.caseId, res.id, res.orderDetail[0].id);
          this.onCompletePurchase();
        }
        this.shoppingCartDataService.onClearItems();
      }, (error) =>
      {
        this.setDangerAlert(error.message);
      });
  }

  private hasAnUpgradeProduct(): boolean
  {
    return this.shoppingCartDataService.currentShoppingCart.any(x =>
    {
      if(!this.shoppingCartDataService.isProduct(x.item))
      {
        let temporalService: Service = x.item as Service;
        return temporalService.serviceType == ServiceType.Upgrade;
      }
    });
  }

  private getOrderDetailList(): ProductDetail[]
  {
    let productDetailList: ProductDetail[] = [];

    this.currentCart.forEach(item =>
    {
      //Define two paths
      let pd: ProductDetail;
      if (this.shoppingCartDataService.isProduct(item.item))
      {
        //Product
        pd =
        {
          productId: item.item.id,
          quantity: item.quantity,
          quantityExtraAligners: item.item.additionalServices.extraAlignersQuantity ?? 0,
          addDentalMonitoring: item.item.additionalServices.addDentalMonitoring ?? false,
          addIsComplexCase: item.item.additionalServices.addIsComplexCase ?? false,
          caseId: this.shoppingCartDataService.caseId ? this.shoppingCartDataService.caseId : null,
          isService: false
        };
      }
      else
      {
        let serviceItem: Service = item.item as Service;
        //Service
        pd =
        {
          productId: serviceItem.id,
          quantity: 1,
          quantityExtraAligners: serviceItem.additionalServices.extraAlignersQuantity ?? 0,
          addDentalMonitoring: serviceItem.additionalServices.addDentalMonitoring ?? false,
          addIsComplexCase: serviceItem.additionalServices.addIsComplexCase ?? false,
          caseId: this.shoppingCartDataService.caseId ? this.shoppingCartDataService.caseId : null,
          isService: true,
          serviceType: serviceItem.serviceType,
        };
        if (item.item.serviceType == ServiceType.Upgrade)
        {
          pd.newProductUpgradeId = item.item.serviceProductUpgrade.id;
          pd.orderDetailId = item.item.serviceProductUpgrade.orderDetailId;
        }
      }
      productDetailList.push(pd);
    });
    return productDetailList;
  }

  private addCasePurchasedOrders(caseId: number, orderId: number, orderDetailId?: number): void
  {
    let queryDef = new UrlQueryDef();

    const body: any =
    {
      "caseId": caseId,
      "orderId": orderId,
      "orderDetailId": orderDetailId
    };

    this.casePurchasedOrdersDataService.insert(body, queryDef.getRequestConfig(true))
      .subscribe(response =>
      {
        this.setInfoAlert("Pago pendiente actualizado");
      }
      , (error) =>
      {
        this.setDangerAlert(error.message);
      });
  }

  private checkInputValidation(): boolean
  {
    if (this.customerObject.CustomerName === "")
    {
      this.setWarningAlert("Introduzca el nombre");
      return false;
    }

    if (this.customerObject.CustomerEmail === "")
    {
      this.setWarningAlert("Introduzca el correo electrónico");
      return false;
    }
    return true;
  }

  private getChargeObject()
  {
    this.chargeObject = {
      "Method": "bank_account",
      "Amount": this.shoppingCartDataService.getTotal().toFixed(2),
      "Description": "",
      "CustomerName": this.customerObject.CustomerName,
      "CustomerEmail": this.customerObject.CustomerEmail
    };
  }

  private getCustomerObject()
  {
    this.customerObject = {
      "CustomerName": this.currentCustomer.fullName,
      "CustomerEmail": this.currentCustomer.email
    };
  }

  // purchase completed successfully
  private onCompletePurchase()
  {
    if (this.currentCart.length > 0 && this.shoppingCartDataService.currentCartHasService())
    {
      this.shoppingCartDataService.onChargeDoneServices();
    }
  }

  protected onGetQueryDefForGetById()
  {
    let queryDef = new UrlQueryDef();
    queryDef.includes = "OrderDetail,OrderDetail.Product";
    return queryDef;
  }

}
